import { useEffect } from 'react'

/** Imposta titolo, lingua e meta description della pagina. */
export function useDocumentMeta(title: string, description: string, lang: string) {
  useEffect(() => {
    document.title = title
    document.documentElement.lang = lang

    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]')
    if (!meta) {
      meta = document.createElement('meta')
      meta.name = 'description'
      document.head.appendChild(meta)
    }
    meta.content = description
  }, [title, description, lang])
}
